var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xm_anli"},[_vm._m(0),_c('ul',{staticClass:"customerul"},_vm._l((_vm.ctm),function(item,index){return _c('li',{key:index},[_c('img',{attrs:{"src":item.image,"alt":""}})])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xm_anli_bna"},[_c('img',{attrs:{"src":"https://img.hozoin.cn/news_img/2021086/16282133550001568.jpg","alt":""}})])
}]

export { render, staticRenderFns }